import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { ChevronDown, User, X } from 'lucide-react'
import { cn } from '@/lib/utils'
import { getAvatarColor, getInitials } from '@/lib/avatar'

interface TeamMember {
  id: string
  userId: string
  fullName: string | null
  avatarUrl: string | null
}

interface BulkOwnerPickerProps {
  teamMembers: TeamMember[]
  onSelect: (userId: string | null) => void
}

export function BulkOwnerPicker({ teamMembers, onSelect }: BulkOwnerPickerProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="h-7 px-2 text-xs text-background hover:bg-background/15 hover:text-background gap-1"
        >
          <User className="h-3.5 w-3.5" />
          Assign
          <ChevronDown className="h-3 w-3 opacity-70" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="center" className="w-48">
        {teamMembers.map((member) => {
          const colors = getAvatarColor(member.userId || member.fullName)
          return (
            <DropdownMenuItem
              key={member.userId}
              onClick={() => onSelect(member.userId)}
            >
              {member.avatarUrl ? (
                <img
                  src={member.avatarUrl}
                  alt=""
                  className="h-5 w-5 rounded-full mr-2"
                />
              ) : (
                <div
                  className={cn(
                    'h-5 w-5 rounded-full flex items-center justify-center text-[10px] font-medium mr-2',
                    colors.bg,
                    colors.text,
                  )}
                >
                  {getInitials(member.fullName)}
                </div>
              )}
              <span className="text-sm truncate">
                {member.fullName ?? member.userId}
              </span>
            </DropdownMenuItem>
          )
        })}
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={() => onSelect(null)}
          className="text-muted-foreground"
        >
          <X className="h-4 w-4 mr-2" />
          Unassign all
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
